(function () {
  window.GangavaQuickAddLoaded = true;

  function setSuccess(button) {
    button.classList.add('gangava-quick-add--added');
    button.setAttribute('aria-label', 'Añadido al carrito');
    button.setAttribute('title', 'Añadido al carrito');
    window.clearTimeout(button.gangavaResetTimer);
    button.gangavaResetTimer = window.setTimeout(function () {
      if (!button.isConnected) return;
      button.classList.remove('gangava-quick-add--added');
      button.setAttribute('aria-label', button.dataset.gangavaAddLabel || 'Añadir al carrito');
      button.setAttribute('title', button.dataset.gangavaAddLabel || 'Añadir al carrito');
    }, 1800);
  }

  function addFormToCart(form, button, event) {
    if (!button || button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (form.dataset.gangavaQuickAddPending === 'true') return;

    event.preventDefault();
    event.stopImmediatePropagation();
    form.dataset.gangavaQuickAddPending = 'true';
    button.setAttribute('aria-disabled', 'true');
    button.classList.add('loading');
    var spinner = button.querySelector('.loading__spinner');
    if (spinner) spinner.classList.remove('hidden');

    var formData = new FormData(form);
    var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
    var miniCart = window.GangavaMiniCart;
    if (cart && !miniCart && typeof cart.getSectionsToRender === 'function') {
      formData.append('sections', cart.getSectionsToRender().map(function (section) { return section.id; }));
      formData.append('sections_url', window.location.pathname);
    }

    fetch((window.routes && window.routes.cart_add_url) || '/cart/add.js', {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/json' },
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (data) {
          if (!response.ok || data.status) throw new Error(data.description || data.message || 'No se pudo añadir');
          return data;
        });
      })
      .then(function (response) {
        setSuccess(button);
        if (miniCart && typeof miniCart.refreshAndOpen === 'function') {
          miniCart.refreshAndOpen();
        } else if (cart && typeof cart.renderContents === 'function') {
          cart.renderContents(response);
        } else if (window.location && window.routes && window.routes.cart_url) {
          window.location.href = window.routes.cart_url;
        }
      })
      .catch(function (error) {
        console.error(error);
      })
      .finally(function () {
        delete form.dataset.gangavaQuickAddPending;
        button.classList.remove('loading');
        button.removeAttribute('aria-disabled');
        if (spinner) spinner.classList.add('hidden');
      });
  }

  function bindButtons(root) {
    if (!root || typeof root.querySelectorAll !== 'function') return;

    root.querySelectorAll('.gangava-card-quick-add__button[type="submit"]').forEach(function (button) {
      if (button.dataset.gangavaQuickAddBound === 'true') return;
      button.dataset.gangavaQuickAddBound = 'true';
      button.addEventListener('click', function (event) {
        var form = button.form || button.closest('.gangava-card-quick-add form[data-type="add-to-cart-form"]');
        if (form) addFormToCart(form, button, event);
      });
    });
  }

  bindButtons(document);
  document.addEventListener('shopify:section:load', function (event) {
    bindButtons(event.target);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target && event.target.closest('.gangava-card-quick-add form[data-type="add-to-cart-form"]');
    if (!form) return;

    var button = form.querySelector('.gangava-card-quick-add__button[type="submit"]');
    if (button) addFormToCart(form, button, event);
  }, true);
})();
